import permissions from '@enums/user-permissions';
import extractTypes from '@enums/extract-types';

const CompoundExtractsPage = () => import('@/pages/compound-extracts/CompoundExtractsPage.vue');
const CompoundExtractsPageGenerate = () =>
  import('@/pages/compound-extracts/CompoundExtractsPageGenerate.vue');

const routes = [
  {
    path: '/extracts',
    name: 'CompoundExtractsPage', // The name is checked in MainNavbar to construct root navigation
    id: 'compound-extracts',
    component: CompoundExtractsPage,
    linkText: 'navBar.extracts',
    meta: {
      featureKey: 'compoundExtractsEnabled',
      titleExtension: 'navBar.extracts',
      requiresPermission: permissions.canViewCompoundExtracts,
    },
    omitChildrenFromNavbar: true,
    children: [
      {
        path: 'hasu-extract/:extractSeriesId',
        name: 'hasu-extract',
        component: CompoundExtractsPageGenerate,
        meta: {
          featureKey: 'compoundExtractsEnabled',
          requiresPermission: permissions.canViewHasuExtracts,
          titleExtension: 'compoundExtractsPage.hasu',
          type: extractTypes.HASU,
        },
      },
      {
        path: 'aoc-extract/:extractSeriesId',
        name: 'aoc-extract',
        component: CompoundExtractsPageGenerate,
        meta: {
          featureKey: 'compoundExtractsEnabled',
          requiresPermission: permissions.canViewAocExtracts,
          titleExtension: 'compoundExtractsPage.aoc',
          type: extractTypes.AOC,
        },
      },
    ],
    index: 4,
  },
];

export default routes;
